import { render } from "./ForgotPasswordResetContainer.vue?vue&type=template&id=28601f4c"
import script from "./ForgotPasswordResetContainer.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordResetContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__